'use client'

import { useTranslations } from '@/lib/next-shim'
import { Link } from '@/lib/i18n/settings'

export function SitemapPage() {
  const t = useTranslations()

  const pages = [
    { href: '/', label: t('sitemap.home') },
    { href: '/account/dashboard', label: t('sitemap.dashboard') },
    { href: '/account/consultations', label: t('sitemap.consultations') },
    { href: '/account/documents', label: t('sitemap.documents') },
    { href: '/account/profile', label: t('sitemap.profile') },
    { href: '/help', label: t('sitemap.help') },
  ]

  return (
    <main className="max-w-2xl mx-auto px-4 py-12">
      <h1 className="text-2xl font-bold text-gray-900 mb-8">{t('sitemap.title')}</h1>
      <nav aria-label={t('sitemap.title')}>
        <ul className="space-y-3 list-disc list-inside">
          {pages.map((page) => (
            <li key={page.href}>
              <Link href={page.href} className="text-blue-700 underline hover:text-blue-900">
                {page.label}
              </Link>
            </li>
          ))}
        </ul>
      </nav>
    </main>
  )
}
